import React, { memo, useCallback } from "react";
import clsx from "clsx";
import { useFormContext } from "react-hook-form";

import { Editor, HookFormInputGroup } from "components";

// Base implementation of Editor field for react-hook-form
// be careful with defaultValues for editor - Only element or decorator nodes can be appended to the root node!
// https://lexical.dev/docs/concepts/nodes

type HookFormEditorProps = {
	name: string;
	isLoading: boolean;
	defaultValues: string;
	onChange?: Function;
	onBlur?: Function;
	maxLength?: number;
	className?: string;
};

const HookFormEditor = ({
	name,
	isLoading,
	defaultValues,
	onChange,
	onBlur,
	maxLength = 1000,
	className,
}: HookFormEditorProps) => {
	const formMethods = useFormContext();

	const {
		formState: { errors },
		register,
		setValue,
	} = formMethods;

	const handleChange = useCallback(
		value => {
			setValue(name, value, { shouldDirty: true });
			onChange?.(value);
		},
		[name, onChange, setValue],
	);

	const handleOnBlur = useCallback(
		value => {
			onBlur?.(value);
		},
		[onBlur],
	);

	return (
		<div className={`${clsx(className)} w-100`}>
			<Editor
				namespace={name}
				isLoading={isLoading}
				defaultValues={defaultValues}
				onChange={handleChange}
				onBlur={handleOnBlur}
				maxLength={maxLength}
			/>
			<HookFormInputGroup
				name={name}
				register={register}
				errors={errors}
				hidden
			/>
		</div>
	);
};

const component = memo(HookFormEditor);
export { component as HookFormEditor };
